import { render, staticRenderFns } from "./MallAdMinusModal.vue?vue&type=template&id=fafe14e8&scoped=true&"
import script from "./MallAdMinusModal.vue?vue&type=script&lang=js&"
export * from "./MallAdMinusModal.vue?vue&type=script&lang=js&"
import style0 from "./MallAdMinusModal.vue?vue&type=style&index=0&id=fafe14e8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafe14e8",
  null
  
)

export default component.exports